var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarToggleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1b365b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,.87a12.12,12.12,0,1,0,8.58,3.55A12.16,12.16,0,0,0,13,.87ZM13,26a13,13,0,1,1,9.19-3.81A13,13,0,0,1,13,26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.36,3c-.12,0-.22-.17-.23-.4s.09-.42.21-.43l.45,0c.11,0,.21.18.21.41s-.1.42-.21.42a3,3,0,0,0-.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,13a.4.4,0,0,1-.41-.4A10,10,0,0,1,4.88,6.26a10.75,10.75,0,0,1,5.87-3.65.41.41,0,0,1,.5.29.39.39,0,0,1-.3.48A9.93,9.93,0,0,0,5.53,6.74a9.19,9.19,0,0,0-2.1,5.86.37.37,0,0,1-.13.28A.38.38,0,0,1,3,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,9H8a.82.82,0,0,0,0,1.64h9A.82.82,0,0,0,17,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.78,12.54h-9a.82.82,0,0,0,0,1.64h9a.82.82,0,0,0,0-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,16.08H8a.83.83,0,0,0,0,1.65h9a.83.83,0,0,0,0-1.65Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarToggleIcon);
export default __webpack_public_path__ + "static/media/sidebar-toggle-icon.c3e2b32d3b1435e8547b23b674d0cf55.svg";
export { ForwardRef as ReactComponent };